import { FieldMap } from '../types/forms/fields'
import { additionalLabsField } from './fields/additionalLabs'
import { cordBloodBankingField } from './fields/cordBloodBanking'
import { cordBloodGasesField } from './fields/cordBloodGases'
import { pkuScreenField } from './fields/pkuScreen'
import { LabSection, LabType } from './types'

export const labSections: Record<LabType, LabSection[]> = {
  [LabType.NEONATAL]: [
    { type: 'cord-blood-banking' },
    { type: 'cord-blood-gases' },
    { type: 'pku-screen' },
    { type: 'additional-labs' },
  ],
}

export const neonatalLabField: FieldMap = {
  name: 'Neonatal Labs',
  children: {
    cordBloodBanking: cordBloodBankingField,
    cordBloodGases: cordBloodGasesField,
    pkuScreen: pkuScreenField,
    additionalLabs: additionalLabsField,
  },
}

export const labFieldByType: Record<LabType, FieldMap> = {
  [LabType.NEONATAL]: neonatalLabField,
}
